import { render } from "./ItemOnlyTextComponent.vue?vue&type=template&id=5867b186&scoped=true"
import script from "./ItemOnlyTextComponent.vue?vue&type=script&lang=js"
export * from "./ItemOnlyTextComponent.vue?vue&type=script&lang=js"

import "./ItemOnlyTextComponent.vue?vue&type=style&index=0&id=5867b186&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5867b186"]])

export default __exports__